var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isFontAwesome)?_c('div',{staticClass:"text-center"},[_c('font-awesome-icon',{staticClass:"align-text-top",class:_vm.faClass,style:(_vm.customFaStyle),attrs:{"icon":_vm.iconSvg}})],1):_c('div',{domProps:{"innerHTML":_vm._s(_vm.iconSvg)}})
}
var staticRenderFns = []

export { render, staticRenderFns }